import { render } from "./BusinessNavigation.vue?vue&type=template&id=a9b04156"
import script from "./BusinessNavigation.vue?vue&type=script&lang=js"
export * from "./BusinessNavigation.vue?vue&type=script&lang=js"

import "./BusinessNavigation.vue?vue&type=style&index=0&id=a9b04156&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__